(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelSheet',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.hide-pricing').on('change', function toggle() {
			if ($(this).is(':checked')) {
				$('.allow-online-booking').addClass('hidden');
			} else {
				$('.allow-online-booking').removeClass('hidden');
			}
		});

		$(document).bind('drag-drop-files-changed', function attachmentsChanged(e, data) {
			$('#hotelsheet-attachments_changed').val(1);
		});

		Adzuki.Editor('#hotelsheet-notes');
		Adzuki.Editor('#hotelsheet-message');

		// only visible when editing an existing sheet
		if ($('#hotelsheet-client_message').length) {
			Adzuki.Editor('#hotelsheet-client_message');
		}

		// Adjustments to commission
		$('.adjustment-amount, .adjustment').on('change', function changeAdjustmentAmount(e) {
			adjustCommission($(this));
		});

		$('.select-new-rooms').on('click', function selectNewRooms(e) {
			var showAlert = false, 
				url       = $(this).attr('href');
			e.preventDefault();

			$('.adjustment-amount').each(function eachAdjustmentAmount() {
				if (parseFloat($(this).val()) > 0) {
					showAlert = true;
				}
			});

			if (showAlert) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Clicking ok will remove any adjustments to the commission that you\'ve made. Would you like to continue?',
					confirm: function confirm() {
						$('.new-rooms-loader').css('visibility', 'visible');
						window.location.href = url;
					}
				});
			} else {
				$('.new-rooms-loader').css('visibility', 'visible');
				window.location.href = url;
			}
		});

		updateAdjustmentAmount();
	};

	function adjustCommission(obj) {
		const elementIndex         = $(obj).data('index'),
		      adjustmentElement    = $('.adjustment-amount[data-index="' + elementIndex + '"]'),
		      adjustmentValue      = parseFloat(adjustmentElement.val()),
		      isAddition           = $('.adjustment[data-index="' + elementIndex + '"]').val()=== '+',
		      baseAmount           = parseFloat(adjustmentElement.data('original-amount')),
		      adminMarkup          = parseFloat($('#hotelsheet-markup_admin_fee_percentage').val())/ 100,
			  adminMarkupAmount    = parseFloat($('.adjustment-amount[data-index="' + elementIndex + '"]').val()) * adminMarkup,
		    //   markupLowPercent     = parseFloat($('#hotelsheet-markup_low_percentage').val())/100,
		      markupHighPercent    = parseFloat($('#hotelsheet-markup_high_percentage').val())/100,
		      sellingPrice         = parseFloat($('.selling-price[data-index="' + elementIndex + '"]').val()),
		    //   calculatedMarkupLow  = sellingPrice * markupLowPercent,
		      calculatedMarkupHigh = sellingPrice * markupHighPercent,
			  adjustedAmount       = $('.adjustment-amount[data-index="' + elementIndex + '"]').val();

		let newAmount;
		if (isAddition) {
			// Include admin markup when adding
			const markupAmount = adjustmentValue; // * (1 + adminMarkup);
			newAmount = baseAmount + markupAmount;
		} else {
			newAmount = baseAmount - adjustmentValue;
		}

		// Round to 2 decimal places
		newAmount = Math.round(newAmount * 100) / 100;

		// Check if the new amount is valid
		if (newAmount < 0) {
			Adzuki.StatusMessage('error', 'Amount cannot go below $0');

			// Set the amount to 0
			$('.adjustment-amount[data-index="' + elementIndex + '"]').val(0);
			$('.adjustment-amount[data-index="' + elementIndex + '"]').trigger('change');
		} else if (calculatedMarkupHigh > 0 && (adjustedAmount > calculatedMarkupHigh)) { // Check if the new amount is too high
			Adzuki.StatusMessage('error', 'Amount cannot exceed ' + accounting.formatMoney(calculatedMarkupHigh) + '. The maximum markup is based on an increase of no more than ' + (100 * markupHighPercent) + '% of the selling price.');

			// Set the amount to the maximum allowed
			$('.adjustment-amount[data-index="' + elementIndex + '"]').val(accounting.toFixed(calculatedMarkupHigh, 2));
			$('.adjustment-amount[data-index="' + elementIndex + '"]').trigger('change');
		} else {
			$('.adjustment-amount-revised[data-index="' + elementIndex + '"]').html(accounting.formatMoney(newAmount));

			if (isAddition) {
				$('.admin-fee[data-index="' + elementIndex + '"]').html(accounting.formatMoney(adminMarkupAmount));
				$('.saved-admin-fee[data-index="' + elementIndex + '"]').val(adminMarkupAmount);
			} else {
				$('.admin-fee[data-index="' + elementIndex + '"]').html(accounting.formatMoney(0));
				$('.saved-admin-fee[data-index="' + elementIndex + '"]').val(0);
			}
		}
	}

	function updateAdjustmentAmount()
	{
		$('.adjustment-amount').each(function eachAdjustmentAmount() {
			if (parseFloat($(this).val()) > 0) {
				$(this).trigger('change');
			}
		});
	}
}(jQuery, window.Adzuki || {}));
